export default __webpack_public_path__ + "0007fc2b98690c4e197488cf7bcdbfc8.png";